<template>
    <div v-loading="isloading" id="printMe">
        <el-descriptions class="margin-top" title="查看详情" :column="2" size="small" border>
            <template slot="extra">
                <el-select v-model="calcid" size="mini" placeholder="请选择计算项" v-if="tableName==='Observation'" @change="handleCalcChange">
                    <el-option v-for="item in calcoptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
                <el-button icon="el-icon-download" size="mini" @click="downloadCSV" style="margin-left:10px;">下载CSV</el-button>
                <el-button icon="el-icon-printer" size="mini" @click="print">打印</el-button>
            </template>
            <el-descriptions-item v-for="(value,key,index) in entityDatabyFilter" :key="index">
                <template slot="label">
                    {{key}}
                </template>
                {{value}}
            </el-descriptions-item>
        </el-descriptions>

        <el-descriptions class="margin-top" title="预警信息&对比结果" :column="1" size="small" border v-if="AlertMessage!==''||ComparisonResult!==''">
            <el-descriptions-item label="预警信息" :label-class-name="labelclass" :content-class-name="contentclass" v-if="AlertMessage!==''">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td v-for="(tditem1,index) in JSON.parse(AlertMessage)" :key="'col'+index">{{tditem1.longname}}</td>
                    </tr>
                    <tr>
                        <td v-for="(tditem2,index) in JSON.parse(AlertMessage)" :key="'data'+index">{{tditem2.value}}</td>
                    </tr>
                </table>
            </el-descriptions-item>
            <el-descriptions-item label="对比结果" v-if="ComparisonResult !== ''">
            <div v-html="ComparisonResult">
            </div>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" title="水质参数" :column="2" size="small" v-if="tableName==='Observation'" border>
            <el-descriptions-item v-for="(value,key,index) in entityDataExtra" :key="index">
                <template slot="label">
                    {{key}}
                </template>
                {{value}}
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" title="数据图表" :column="2" size="small" border>
            <el-descriptions-item>
                <template slot="label">
                    三维图
                </template>
                <plotchart :chartData="entityData.chart3d" :chartType="2" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    等值线图
                </template>
                <contour-plot :chartData="entityData.contour" />
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
    import { getEntityFull, tableInfo2, getCalcList, getEntityFullByCalcId, getDataFile, downloadFile } from '@/api/utils';
    import XEUtils from 'xe-utils';
    import { Print } from '@/utils/validate';
    import ContourPlot from '@/components/ContourPlot';
    import Plotchart from '@/components/Plotchart';

    export default {
        name: 'Detailinfo',
        components: {
            ContourPlot,
            Plotchart
        },
        props: {
            tableName: {
                type: String
            },
            meta: {
                type: Object
            }
        },
        data() {
            return {
                isloading: true,
                tableColumns: [],
                entityData: {},
                calcoptions: [],
                calcid: '',
                AlertMessage: "",
                ComparisonResult:"",
                AlertType: -1,
                notShowCols: [
                    'Id',
                    'AlertMessage',
                    'ComparisonResult',
                    'BGWaterId',
                    'Type2WaterId',
                    'EquipmentId'
                ],
                extraColumns: [{
                    Field: 'COD',
                    Title: '化学需氧量(mg/L)'
                },
                {
                    Field: 'Conductivity',
                    Title: '电导率(μS/cm)'
                },
                {
                    Field: 'NH3N',
                    Title: '氨氮(mg/L)'
                },
                {
                    Field: 'TP',
                    Title: '总磷(mg/L)'
                },
                {
                    Field: 'TN',
                    Title: '总氮(mg/L)'
                },
                {
                    Field: 'DO',
                    Title: '溶解氧(mg/L)'
                },
                {
                    Field: 'Temperature',
                    Title: '水温(℃)'
                },
                {
                    Field: 'PH',
                    Title: 'PH值'
                },
                {
                    Field: 'NTU',
                    Title: '浊度(NTU)'
                },
                {
                  Field: 'NO3N',
                  Title: '硝酸盐氮(NO3N)'
                }]
            }
        },
        computed: {
            entityDatabyFilter() {
                let newEntityData = {};
                let that = this;
                let keys = Object.keys(this.entityData);
                that.tableColumns.forEach(function (col) {
                    if (that.notShowCols.indexOf(col.Field) === -1) {
                        let key = that.findKeybyCol(keys, col.Field);
                        if (key !== undefined) {
                            newEntityData[col.Title] = that.formatData(col, that.entityData[key]);
                        }
                    }
                });
                return newEntityData;
            },
            entityDataExtra() {
                let newEntityData = {};
                let that = this;
                let keys = Object.keys(this.entityData);
                that.extraColumns.forEach(function (col) {
                    let key = that.findKeybyCol(keys, col.Field);
                    if (key !== undefined) {
                        newEntityData[col.Title] = that.formatData(col, that.entityData[key]);
                    }
                });
                return newEntityData;
            },
            labelclass() {
                if (this.AlertType === 1) return 'red-alert-label';
                else if (this.AlertType === 2) return 'yellow-alert-label';
                return '';
            },
            contentclass() {
                if (this.AlertType === 1) return 'red-alert-content';
                else if (this.AlertType === 2) return 'yellow-alert-content';
                return '';
            }
        },
        async created() {
            await this.getTableCols();
            await this.getEntityFullData();
            await this.getObCalcList();
            this.isloading = false;
        },
        methods: {
            //方法:根据列名查找列对象
            findColbyName(name) {
                return this.tableColumns.find((item) => {
                    return item.Field === name;
                });
            },
            findKeybyCol(keys,colname) {
                return keys.find((item) => {
                    return item === colname;
                });
            },
            //根据列名获取对应的中文title
            getTitlebyColumn(colname) {
                const column = this.findColbyName(colname);
                if (column !== undefined) return column.Title;
                return colname;
            },
            formatData(col, val) {
                let reValue = val;
                if (col !== undefined && col.IsFormat) {
                    switch (col.FormatOption.type) {
                        case 'number'://数字:保留2位小数
                            reValue = val.toFixed(2);
                            break;
                        case 'datetime'://时间:yyyy-MM-dd HH:mm:ss.S 不格式化后支持毫秒
                            reValue = XEUtils.toDateString(val, 'yyyy-MM-dd HH:mm:ss');
                            break;
                        case 'array'://数组:根据Option自定义格式化
                            if (val == null)
                                reValue = val;
                            else if (col.FormatOption.template !== undefined &&
                                col.FormatOption.template != null &&
                                col.FormatOption.template !== '') {
                                reValue = "";
                                val.forEach(cellItem => {
                                    reValue += XEUtils.toFormatString(col.FormatOption.template, cellItem) + '\r\n ';
                                });
                                reValue = reValue.substring(0, reValue.length - 3);
                            }
                            else
                                reValue = val.join(',');
                            break;
                        default:
                    }
                }
                return reValue;
            },
            //事件:计算id列表下拉框选择触发
            async handleCalcChange(val) {
                let res = await getEntityFullByCalcId({ calcId: val }).catch(() => { });
                this.entityData = res.Data.entity;
                this.AlertMessage = this.entityData['AlertMessage'] && this.entityData['AlertMessage'] != null ? this.entityData['AlertMessage'] : '';
                this.AlertType = this.entityData['AlertType'] && this.entityData['AlertType'] != null ? this.entityData['AlertType'] : -1;
                const CComparisonResult = this.entityData['ComparisonResult'] && this.entityData['ComparisonResult'] != null ? this.entityData['ComparisonResult'] : [];
                this.ComparisonResult = CComparisonResult.length > 0 ? CComparisonResult.join('<br>') : '';
                let rn = Math.random().toString(36).substring(3,9)
                const c3ddata = {
                    pdata: res.Data.chart3d,
                    size: {width: 500, height: 400},
                    chartid: this.tableName + this.entityData.Id + '-' + rn  + '-' + '3d'
                };
                this.entityData.chart3d = c3ddata;
                const contourdata = {
                    pdata: res.Data.contour,
                    peaks: this.entityData.Peaks,
                    size: {width: 530, height: 400},
                    chartid: this.tableName + this.entityData.Id + '-' + rn  + '-' + 'contour'
                };
                this.entityData.contour = contourdata;
            },
            //事件:下载csv
            async downloadCSV() {
                let res = await getDataFile(this.tableName,{ id: this.entityData.Id }).catch(() => { });
                downloadFile(res);
                this.$message({
                    message: "下载成功",
                    type: 'success'
                });
            },
            //事件:打印
            print() {
                Print();
            },
            //获取:DataTable列定义
            async getTableCols() {
                let params = { tableName: this.tableName };
                let res = await tableInfo2(params).catch(() => { });
                let tableColumnsRes = res.Data;
                tableColumnsRes.sort((a, b) => a.OrderInTable - b.OrderInTable);
                for (let i = 0; i < tableColumnsRes.length; i++) {
                    let col = tableColumnsRes[i];
                    col.FormatOption = col.FormatOption == null || col.FormatOption === '' ? {} : JSON.parse(col.FormatOption);
                }
                this.tableColumns = tableColumnsRes;
            },
            //获取:Entityfull数据
            async getEntityFullData() {
                let res = await getEntityFull(this.tableName, { id: this.meta.id }).catch(() => { });
                this.entityData = res.Data.entity;
                this.AlertMessage = this.entityData['AlertMessage'] && this.entityData['AlertMessage'] != null ? this.entityData['AlertMessage'] : '';
                this.AlertType = this.entityData['AlertType'] && this.entityData['AlertType'] != null ? this.entityData['AlertType'] : -1;
                const CComparisonResult = this.entityData['ComparisonResult'] && this.entityData['ComparisonResult'] != null ? this.entityData['ComparisonResult'] : [];
                this.ComparisonResult = CComparisonResult.length > 0 ? CComparisonResult.join('<br>') : '';
                let rn = Math.random().toString(36).substring(3,9)
                const c3ddata = {
                    pdata: res.Data.chart3d,
                    size: {width: 500, height: 400},
                    chartid: this.tableName + this.meta.id + '-' + rn  + '-' + '3d'
                };
                this.entityData.chart3d = c3ddata;
                const contourdata = {
                    pdata: res.Data.contour,
                    peaks: this.entityData.Peaks,
                    size: {width: 530, height: 400},
                    chartid: this.tableName + this.meta.id + '-' + rn  + '-' + 'contour'
                };
                this.entityData.contour = contourdata;
            },
            //获取:Observation的calc列表getCalcList
            async getObCalcList() {
                if (this.tableName === 'Observation') {
                    let params = { observationId: this.meta.id };
                    let res = await getCalcList(params).catch(() => { });
                    if (res.Code === 1) {
                        if (res.Data.calc.length > 1) {
                            res.Data.calc.forEach(item => {
                                if (item.Id === this.entityData.CalculateId)
                                    this.calcid = item.Id;
                                let itemopt = {
                                    label: "Id:" + item.Id + " - " + item.CreateTime,
                                    value:item.Id
                                }
                                this.calcoptions.push(itemopt);
                            });
                        }
                    }
                }
            },
        }
    }
</script>

<style>
table td{
    white-space:pre-wrap;
    word-wrap: break-word;
}
table th{
    white-space:pre-wrap;
    word-wrap: break-word;
}
</style>
